import dynamic from 'next/dynamic';
import type React from 'react';

import { useHighlightedProductsSponsoredData } from '@/domains/sellerAdsManagement/SponsoredProducts/components/HighlightedProduct/hooks/useHighlightedProductsSponsoredData';
import { useDetail } from '@/productDiscovery/ProductPage/hooks/useDetail';

const LazyHighlightedProduct = dynamic(
  () =>
    import('./LazyHighlightedProduct').then(
      (mod) => mod.LazyHighlightedProduct,
    ),
  {
    ssr: false,
    loading: () => <div className={'h-[91px]'} />,
  },
);

export const HighlightedProductContainer: React.FC = () => {
  const { productId } = useDetail();

  const highlightedProductsSponsoredData =
    useHighlightedProductsSponsoredData();

  if (
    highlightedProductsSponsoredData &&
    highlightedProductsSponsoredData.fetched &&
    !highlightedProductsSponsoredData.data.length
  )
    return null;

  if (
    !highlightedProductsSponsoredData ||
    !highlightedProductsSponsoredData.fetched
  )
    return (
      <div data-testid="highlighted-product-skeleton" className={'h-[91px]'} />
    );

  return (
    <LazyHighlightedProduct
      key={`highlighted-product-${productId}`}
      sponsoredData={highlightedProductsSponsoredData.data}
    />
  );
};
